module.exports = __webpack_public_path__ + "static/logo-a95272e8634f8964ae35b88393809abf.svg";